import React from 'react';
import Style from './Home.module.scss';
import { Box } from "@mui/material";
import { HashLink as Link } from 'react-router-hash-link';
import { info } from "../../info/Info";

const scrollWidthOffset = (el) => {
    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
    const yOffset = -80;
    window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
}

export default function Home({innerRef}) {

    return (
        <Box ref={innerRef} component={'main'} className={Style.container} id={'about'}>
            <Box className={Style.content}>
                <Box className={Style.introWrapper}>
                    <h1 className={Style.intro}>
                        <strong>Cloud, DevOps,
                            Infrastructures</strong>
                    </h1>
                    <p className={Style.bio}>
                        {info.bio}
                    </p>
                </Box>
                <Box className={Style.miniBio}>
                    {info.miniBio.map((bio, index) => (
                        <Box key={index} className={Style.bioItem}>
                            <span className={Style.emoji}>{bio.emoji}</span>
                            <span>{bio.text}</span>
                        </Box>
                    ))}
                </Box>
                <Link to="#contact" className={Style.contactBtn} scroll={el => scrollWidthOffset(el)}>
                    Contact Me
                </Link>
            </Box>
        </Box>
    )
}
